<template>
    <div class="video-text">
        <div class="title">{{ blok.title }}</div>
        <div class="video-container">
            <span v-if="!showVideo && blok.thumbnail.filename && blok.video" class="play-icon"></span>
            <NuxtImg
                v-if="blok.thumbnail.filename"
                :src="blok.thumbnail.filename"
                :alt="blok.thumbnail.alt"
                provider="storyblok"
                format="webp"
                loading="lazy"
                class="thumbnail"
                :class="{ relative: showVideo, 'opacity-0': showVideo }"
                @click="blok.video ? (showVideo = true) : false"
            />
            <div v-if="showVideo || !blok.thumbnail.filename" class="video">
                <iframe
                    :src="`https://www.youtube.com/embed/${blok.video}?&amp;controls=0&autoplay=1&mute=1`"
                    :title="blok.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                ></iframe>
            </div>
        </div>
        <div class="description">
            {{ readMore ? blok.description : blok.description.slice(0, 100) + '...' }}
            <span v-if="!readMore" @click="readMore = true">Read More</span>
            <span v-else @click="readMore = false">Hide Text</span>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    blok: any;
}>();

const readMore = ref(false);
const showVideo = ref(false);
</script>

<style scoped lang="postcss">
.video-text {
    @apply flex flex-col;
    .title {
        @apply text-xl font-semibold text-primary;
    }
    .video-container {
        @apply relative my-2 max-w-[500px] md:max-w-none;
        &:hover {
            .play-icon {
                @apply opacity-90;
            }
        }
        .play-icon {
            transition: all 0.4s ease;
            @apply absolute top-[50%] left-[50%] w-[44px] h-[44px] -mt-[22px] -ml-[22px] bg-secondary rounded-full pointer-events-none;
            &:before {
                @apply top-[50%] left-[50%] -mt-[9px] -ml-[4px] z-[3] content-[''] absolute border-transparent border-l-secondary border-l-[11px] border-y-[9px] border-r-0;
            }
            &:after {
                @apply content-[''] absolute top-2 right-2 left-2 bottom-2 bg-white rounded-full;
            }
        }
        .thumbnail {
            @apply object-cover w-full h-full cursor-pointer max-h-[275px] md:max-h-none;
        }
        .video {
            @apply w-full h-full;
            :deep(iframe) {
                @apply w-full h-full absolute top-0 left-0 right-0 bottom-0;
            }
        }
    }
    .description {
        @apply flex flex-col;
        span {
            @apply block cursor-pointer text-primary text-lg font-semibold;
        }
    }
}
</style>
